import { create } from "zustand";
import { checkoutStorage } from "../lib/checkout-storage";

interface CheckoutState {
  checkoutId: string | null;
  setCheckoutId: (id: string | null) => void;
  clearCheckout: () => void;
  // Add method to initialize checkout if needed
  initializeCheckout: () => void;
}

export const useCheckoutStore = create<CheckoutState>((set) => ({
  checkoutId: checkoutStorage.get(),
  setCheckoutId: (id) => {
    if (id) {
      checkoutStorage.set(id);
    } else {
      checkoutStorage.clear();
    }
    set({ checkoutId: id });
  },
  clearCheckout: () => {
    checkoutStorage.clear();
    set({ checkoutId: null });
  },
  initializeCheckout: () => {
    // This will be called when we need to ensure a checkout exists
    // The actual creation will be handled by the API hooks
    // The checkout will be created when needed via useEnsureCheckout
  },
}));
